import hkAccess from './hk-access.vue'

export default hkAccess
